import { createSelector } from '@app/utils/createSelector'
import { catchFetchDataError } from '@app/utils/performFetchData'

import type { ApiPromousage } from '@app/packages/api/v2/types/entities'
import { createLoadable } from '@app/packages/thunkSelector/thunkSelector'
import type { SliceState } from '@app/packages/thunkSelector/withCheckedSliceState'
import { withCheckedSliceState } from '@app/packages/thunkSelector/withCheckedSliceState'

import { callV2Api } from '@app/store/actions/api'
import { createReduxSlice } from '@app/store/redux_slice'
import { profileUserResultSelector } from '@app/store/selectors/profile'

import { routingUUIDSelector } from './routing'

const promocodeValueSlice = createReduxSlice<string>('promocode_value')

const promocodesSlice = createReduxSlice<SliceState<ApiPromousage[]>>('promocodes')
export const promocodesSyncSlice = createReduxSlice<{ uuid: string }>('promocodes_sync')

export const promocodeSelector = createSelector([promocodeValueSlice.selector], value => value ?? '')

export const setPromocodeValueSlice = (value: string) => promocodeValueSlice.set(value)

export const promocodesModelsResultSelector = createSelector(
  [promocodesSlice.selector, promocodesSyncSlice.selector, profileUserResultSelector, routingUUIDSelector],
  (sliceState, sync, userResult, uuid) =>
    createLoadable(c => {
      const user = c.unwrap(userResult)
      // promo_usages is parents only (authenticate_parent!); anyone else gets a 401 read as a lost session.
      if (user?.account_type !== 'parent') return EMPTY_LIST
      return withCheckedSliceState(c, {
        sliceState,
        slice: promocodesSlice,
        hash: [uuid, sync?.uuid ?? '', user.id].join(':'),
        load: async dispatch => {
          const { getPromoUsages } = await import('@app/packages/api/v2/actions/promo_usages')
          const resp = await dispatch(callV2Api(getPromoUsages())).catch(catchFetchDataError(dispatch, 'Promocodes fetch failed'))
          return resp.data
        },
      })
    })
)

const EMPTY_LIST: ApiPromousage[] = []
